import { motion } from "framer-motion";
import RegistrationForm from "@/components/RegistrationForm";
import SectionBg from "@/components/SectionBg";
import Countdown from "@/components/Countdown";
import { scrollToId } from "@/lib/attribution";
import { HERO, WEBINAR, HOST, ASSETS } from "@/data/content";

const line = {
  hidden: { y: "110%" },
  show: (i) => ({ y: "0%", transition: { duration: 0.9, delay: 0.25 + i * 0.12, ease: [0.22, 1, 0.36, 1] } }),
};

const MaskedLine = ({ children, i, className }) => (
  <span className="block overflow-hidden">
    <motion.span className={`block ${className || ""}`} custom={i} variants={line} initial="hidden" animate="show">
      {children}
    </motion.span>
  </span>
);

export default function Hero() {
  return (
    <section className="relative min-h-screen grid lg:grid-cols-2" data-testid="hero-section">
      <SectionBg src={ASSETS.bg.luxHomeDusk} opacity={0.20} position="center 60%" />
      <div className="relative z-10 flex flex-col justify-center px-6 sm:px-12 lg:px-16 pt-28 pb-12 lg:pt-24">
        <p className="font-mono text-[10px] tracking-[0.2em] text-white/30 mb-8">{WEBINAR.dateLine}</p>
        <p className="font-mono text-[10px] tracking-[0.25em] text-[#D9622B] mb-5">{WEBINAR.eyebrow}</p>
        <h1 className="hero-h1" data-testid="hero-h1">
          <MaskedLine i={0}>{HERO.h1a}</MaskedLine>
          <MaskedLine i={1} className="text-[#D9622B]">{HERO.h1b}</MaskedLine>
          <MaskedLine i={2} className="opacity-60 text-[0.62em]">{HERO.h1c}</MaskedLine>
        </h1>
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.9, duration: 0.8 }} className="mt-6 text-[15px] text-white/55 max-w-xl leading-relaxed">
          The free live review that shows <span className="text-[#D9622B]">veterans</span> and <span className="text-[#D9622B]">active-duty service members</span> in Georgia, Florida, North Carolina & Tennessee exactly what they qualify for and what it actually costs out of pocket — from a retired Army veteran who navigated her own VA loan with no guidance.
        </motion.p>
        <motion.blockquote initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.05, duration: 0.8 }} className="mt-6 border-l-2 border-[#D9622B] pl-4 italic text-sm text-white/60 max-w-lg">
          {HERO.blockquote}
        </motion.blockquote>
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.15, duration: 0.8 }}>
          <Countdown />
        </motion.div>
        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 1.2, duration: 0.7 }} className="mt-8">
          <button data-testid="hero-cta-btn" onClick={() => scrollToId("register")} className="px-8 py-4 btn-primary text-black font-black text-sm tracking-[0.1em]">
            ✓ RESERVE MY FREE SEAT
          </button>
          <p className="mt-2.5 text-[11px] text-white/25 font-mono tracking-wide">LOW TICKET NOTICE! — Seats fill fast</p>
        </motion.div>
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.4, duration: 0.8 }} className="mt-12 flex items-center gap-4" data-testid="hero-host-module">
          <img src={ASSETS.headshot} alt={HOST.name} className="w-14 h-14 rounded-full border-2 border-[#D9622B] object-cover object-top" data-testid="hero-host-headshot" />
          <div>
            <p className="text-sm font-bold text-[#F0ECE4]">{HOST.name}</p>
            <p className="text-[11px] text-white/40">{HOST.company} · NMLS# {HOST.nmls}</p>
          </div>
        </motion.div>
      </div>

      <div className="relative z-10 flex items-center justify-center px-6 sm:px-12 pb-16 lg:pb-0 lg:pt-24">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.6, duration: 0.9, ease: [0.22, 1, 0.36, 1] }} className="relative z-10 w-full max-w-md">
          <RegistrationForm variant="hero" />
        </motion.div>
      </div>
    </section>
  );
}
